{
  "version": 1,
  "asset_id": "51a60550-95b7-4f75-93d0-7c2af4700942",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/51a60550-95b7-4f75-93d0-7c2af4700942/resultado_5.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/51a60550-95b7-4f75-93d0-7c2af4700942/resultado_5.png",
  "original_filename": "resultado_5.png",
  "size": 996126,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:18Z"
}
